export const app = {
  api: process.env.REACT_APP_API
};
